import { Spin } from 'antd'

const Circular = () => {
    return (
        <div className='h400px w-100 d-flex justify-content-center align-items-center'>
            <Spin></Spin>
        </div>
    )
}

export default Circular
